// React

// Packages

// Utilities

// Components

const ResultSetFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    const {
        Id: Result___Id,
        Type__c,
        Name__c,
        Description__c,
    } = utilities.results.get(id);

    // ///////////////////
    // RESULT ID
    // ///////////////////

    form.setValue('Result___Id', Result___Id);

    // ///////////////////
    // CHOICE
    // ///////////////////

    form.setValue('Choice', choice);
    form.setValue('Type__c', Type__c);

    // ///////////////////
    // DETAILS
    // ///////////////////

    // Basic fields
    form.setValue('Name__c', Name__c);
    form.setValue('Description__c', Description__c);

    // ///////////////////
    // REFLECTION
    // ///////////////////

    const reportDetail = utilities.reportDetails.getFromResultIdAndReportId(
        Result___Id,
        REPORT_ID
    );
    const hasReflection = reportDetail?.Description__c;

    form.setValue('Reflection___Id', reportDetail.Id || null);

    if (hasReflection) {
        form.setValue(
            'Reflection___Description__c',
            reportDetail.Description__c
        );
    }
};

export default ResultSetFieldValues;
